export enum AtiraLinkPlanDesign {
  PLAN_0 = 'off',
  PLAN_1 = 'limited',
  PLAN_2 = 'unlimited',
}
